export enum ProposalItemActionTypes {
  SET_STATE = 'PROPOSAL_ITEM.SET_STATE',
  GET_PROPOSAL = 'PROPOSAL_ITEM.GET_PROPOSAL',
  BUY_VOTING_TOKEN = 'PROPOSAL_ITEM.BUY_VOTING_TOKEN',
  VOTE = 'PROPOSAL_ITEM.VOTE',
  CREATE_PROPOSAL = 'PROPOSAL_ITEM.CREATE_PROPOSAL',
  BRIDGE_CREATE_PROPOSAL = 'PROPOSAL_ITEM.BRIDGE_CREATE_PROPOSAL',
  GET_PRICES_FOR_VOTING = 'PROPOSAL_ITEM.GET_PRICES_FOR_VOTING',
}
